var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a0",attrs:{"id":"a0"}},[_c('div',{staticClass:"f1",on:{"click":_vm.icon}},[_vm._v("咨询")]),_c('div',{staticClass:"f2",on:{"click":_vm.left}},[_vm._v("0元会员免费学")]),_c('div',{staticClass:"f3",attrs:{"id":"f3"},on:{"click":_vm.right}},[_vm._v("立即订阅")])])
}
var staticRenderFns = []

export { render, staticRenderFns }